import {z} from 'zod';

const LanguageCodeSchema = z.string();

export const VehicleLocalizedContentItemSchema = z.object({
  language: LanguageCodeSchema,
  titleExtension: z.string().nullable(),
  description: z.string().nullable(),
});
export type VehicleLocalizedContentItem = z.infer<typeof VehicleLocalizedContentItemSchema>;

export const VehicleLocalizedContentListResponseSchema = z.array(VehicleLocalizedContentItemSchema);
export type VehicleLocalizedContentListResponse = z.infer<
  typeof VehicleLocalizedContentListResponseSchema
>;

export const GetVehicleLocalizedContentArgSchema = z.object({
  vehicleId: z.string(),
});
export type GetVehicleLocalizedContentArg = z.infer<typeof GetVehicleLocalizedContentArgSchema>;

export const SetVehicleLocalizedContentArgSchema = z.object({
  vehicleId: z.string(),
  language: LanguageCodeSchema,
  body: z.object({
    titleExtension: z.string().nullable(),
    description: z.string().nullable(),
  }),
});
export type SetVehicleLocalizedContentArg = z.infer<typeof SetVehicleLocalizedContentArgSchema>;

export const DeleteVehicleLocalizedContentArgSchema = z.object({
  vehicleId: z.string(),
  language: LanguageCodeSchema,
});
export type DeleteVehicleLocalizedContentArg = z.infer<
  typeof DeleteVehicleLocalizedContentArgSchema
>;
